var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMagnify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_11720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.5C8.871 10.5 9.375 11.004 9.375 11.625C9.375 12.246 8.871 12.75 8.25 12.75C7.629 12.75 7.125 12.246 7.125 11.625C7.125 11.004 7.629 10.5 8.25 10.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9H7.5V6H9C9.82725 6 10.5 5.32725 10.5 4.5C10.5 3.67275 9.82725 3 9 3H7.5C6.67275 3 6 3.67275 6 4.5V4.875H4.5V4.5C4.5 2.8455 5.8455 1.5 7.5 1.5H9C10.6545 1.5 12 2.8455 12 4.5C12 6.1545 10.6545 7.5 9 7.5V9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.838 15.7748C18.032 14.3438 18.752 12.5048 18.752 10.4993C18.752 7.58626 17.2295 5.02576 14.9427 3.55801L14.1935 4.85551C16.0332 6.06226 17.252 8.13976 17.252 10.4993C17.252 14.2215 14.2242 17.2493 10.502 17.2493C6.78045 17.2493 3.75195 14.2215 3.75195 10.4993H2.25195C2.25195 15.0488 5.9532 18.7493 10.502 18.7493C12.5067 18.7493 14.3465 18.0293 15.7775 16.8353L21.4415 22.4993L22.502 21.4388L16.838 15.7748Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_11720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMagnify);
export default __webpack_public_path__ + "static/media/question-magnify.583689c87c2e64e01de3588780425514.svg";
export { ForwardRef as ReactComponent };